import { useRouter } from 'next/router'
import type { ComponentProps } from 'react'
import { ROUTES_WITHOUT_FOOTER } from '~/config/routes-without-footer'
import { cn } from '~/lib/utils'

export const MainContainer = ({
	children,
	className,
	...props
}: ComponentProps<'div'>) => {
	const router = useRouter()

	return (
		<div
			{...props}
			className={cn(
				'container relative mx-auto flex min-h-[80vh] flex-col gap-y-6 py-6',
				ROUTES_WITHOUT_FOOTER.includes(router.route)
					? 'min-h-[100dvh]'
					: 'min-h-[80dvh]',
				className,
			)}
		>
			{children}
		</div>
	)
}
